import React from 'react';
import { List, ListItem, ListItemText } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { SmartDiaryEntry } from '../type';
import { LabelsTooltip } from '../SmartDiaryList';
import { CustomCPTLabel } from '../SmartDiaryList/CustomCPTLabel';
import { SyncError } from './hooks';

const useStyles = makeStyles(() => ({
  listItem: {
    paddingTop: 0,
    paddingBottom: 0
  }
}));

type UnknownErrorProps = {
  errors: SyncError[];
  smartEntries: SmartDiaryEntry[];
};
export const UncategorizedError: React.FC<UnknownErrorProps> = ({
  errors,
  smartEntries
}: UnknownErrorProps) => {
  const classes = useStyles();
  return (
    <List data-testid="error-item">
      {errors.map((error) => {
        const erroredEntry = smartEntries.filter((x) => x.id == error.id)[0];
        return (
          <ListItem key={error.id} className={classes.listItem}>
            {erroredEntry ? (
              <LabelsTooltip smartEntry={erroredEntry}>
                <ListItemText>
                  {error.description}
                  <CustomCPTLabel smartEntry={erroredEntry} />
                </ListItemText>
              </LabelsTooltip>
            ) : (
              <ListItemText>{error.description}</ListItemText>
            )}
          </ListItem>
        );
      })}
    </List>
  );
};
